import { useAllocationHistoryV1 } from "../../reactHooks/api/useAllocationHistoryV1";
import { usePortfolio } from "../../reactHooks/api/usePortfolio/usePortfolio";
import { useHistoricVolatility } from "../../reactHooks/api/useHistoricVolatility";
import { Period } from "@iliotech/generated-api";

export interface useRiskWireProps {
  portfolioId: string;
  sendRequest: unknown;
  frequency: "Daily" | "Monthly";
  overridePeriod?: Period;
}

export function useRiskWire({
  portfolioId,
  frequency,
  overridePeriod,
}: useRiskWireProps) {
  const allocationHistory = useAllocationHistoryV1(
    portfolioId!,
    overridePeriod
  );
  const portfolioRequest = usePortfolio(portfolioId!);
  const portfolioInfo = portfolioRequest.data?.data;
  const volatilityResponse = useHistoricVolatility(
    portfolioId,
    overridePeriod,
    frequency
  );

  // data wire will always return
  // required
  //   portfolioId
  //   portfolioInfo -> as without that this means a critical error happened
  // this will allow to return an error boundary later
  // serverData
  //      isloading -> for the loading indicators, boolean
  //      specifica api calls from the hook
  // actions
  // actions that affect the page

  const required = {
    portfolioId,
    portfolioInfo,
  };
  const serverData = {
    allocationHistory,
    volatilityResponse,
  };
  const actions = {};

  return {
    required,
    serverData,
    actions,
    portfolioId,
  };
}
